import MedicalInputGroup from "src/components/pages/Settings/YachtSetUp/MedicalHistory/Inputs/MedicalInputGroup";
import {
  StyledMedicalContent,
  StyledMedicalContentLabel,
} from "src/components/pages/Settings/YachtSetUp/MedicalHistory/MedicalHistory.styled";
import { useSelector } from "src/redux/hooks";
import { StyledTable, StyledTh, StyledTr } from "src/styled";

import MedicalSectionWrapper from "../MedicalSectionWrapper";
import MedicalLeaveHistoryRow from "./MedicalLeaveHistoryRow";

const MedicalLeaveHistory = () => {
  const { medLeaveHistory, inputs } = useSelector(
    state => state.medicalHistory.leaveHistory,
  );
  // const map
  return (
    <MedicalSectionWrapper name="Medical Leave History">
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}>
        <div>
          {medLeaveHistory.list && (
            <StyledTable>
              <thead>
                <StyledTr>
                  <StyledTh>Date</StyledTh>
                  <StyledTh>Status</StyledTh>
                  <StyledTh>Action</StyledTh>
                </StyledTr>
              </thead>
              <tbody>
                {medLeaveHistory.list?.map((data, i) => (
                  <MedicalLeaveHistoryRow
                    key={`leave-${data.leaveid}-${i}`}
                    {...data}
                  />
                ))}
              </tbody>
            </StyledTable>
          )}
        </div>
        <div>
          <StyledMedicalContentLabel>
            Total this period:
          </StyledMedicalContentLabel>
          <StyledMedicalContent>
            <StyledMedicalContentLabel>Onboard: </StyledMedicalContentLabel>
            <p style={{ margin: 0 }}>{medLeaveHistory.daysOnBoard} days</p>
          </StyledMedicalContent>
          <StyledMedicalContent>
            <StyledMedicalContentLabel>Leave: </StyledMedicalContentLabel>
            <p style={{ margin: 0 }}>{medLeaveHistory.daysOffLeave} days</p>
          </StyledMedicalContent>
        </div>
        <MedicalInputGroup inputs={inputs} />
      </div>
    </MedicalSectionWrapper>
  );
};
export default MedicalLeaveHistory;
